const baseUrl = "https://api.pictsnap.simhive.com/api";
// const baseUrl = "http://192.168.43.119:3000/api";
// const baseUrl = "http://localhost:3000/api"
// const baseUrl = "http://10.252.130.118:3000/api";

export default baseUrl;
